import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { PRINTING_JOB_WORK_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const PrintingJobWorkApi = createApi({
  reducerPath: "PrintingJobWork",
  baseQuery,
  tagTypes: ["PrintingJobWork"],
  endpoints: (builder) => ({
    getPrintingJobWork: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: PRINTING_JOB_WORK_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: PRINTING_JOB_WORK_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["PrintingJobWork"],
    }),
    getPrintingJobWorkById: builder.query({
      query: ({ id }) => {
        return {
          url: `${PRINTING_JOB_WORK_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["PrintingJobWork"],
    }),
    addPrintingJobWork: builder.mutation({
      query: (payload) => ({
        url: PRINTING_JOB_WORK_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PrintingJobWork"],
    }),
    updatePrintingJobWork: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${PRINTING_JOB_WORK_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["PrintingJobWork"],
    }),
    deletePrintingJobWork: builder.mutation({
      query: (id) => ({
        url: `${PRINTING_JOB_WORK_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PrintingJobWork"],
    }),
  }),
});

export const {
  useGetPrintingJobWorkQuery,
  useGetPrintingJobWorkByIdQuery,
  useAddPrintingJobWorkMutation,
  useUpdatePrintingJobWorkMutation,
  useDeletePrintingJobWorkMutation,
} = PrintingJobWorkApi;

export default PrintingJobWorkApi;
